import { Stats } from "@usereactify/search";
import React from "react";
import tw from "twin.macro";

const Wrapper = tw.div`text-left text-hint md:pl-mini text-primary`;

export type StatsProps = {
  resultStats: {
    hidden: number;
    numberOfResults?: number;
    promoted: number;
    time: number;
  };
};

const RenderProductStats = (props: StatsProps) => {
  const productCount = props?.resultStats?.numberOfResults || 0;
  const label = productCount > 1 ? " products" : " product";
  return (
    <Wrapper data-testid="product-stats-label">
      {productCount > 0 ? productCount + label : null}
    </Wrapper>
  );
};

export const FilterSectionProductStats = () => {
  return <Stats render={RenderProductStats} />;
};
